/**
 * This import should point to uicore/constants,
 * because the E2E tests break,
 * due to importing the whole uicore library
 * in a place which can't read the .tsx format.
 */
import { ONE_MINUTE } from '@lucidlink/uicore/constants';
export const FILESPACE_CLIENT_QUERY_KEYS = {
    // Permissions related
    FilespaceCheckAccess: 'filespace_check_access',
    FilespaceDirectoryContents: 'directory_contents',
    FilespaceDirectoryId: 'directory_id',
    FilespaceDirectoryPath: 'directory_path',
    FilespaceGrantAccess: 'filespace_grant_access',
    FilespaceGrantAccessMultiple: 'filespace_grant_access_multiple',
    FilespacePrincipalAccess: 'filespace_principals_access',
    FilespaceListAccess: 'filespace_list_access',
    FilespaceRevokeAccess: 'filespace_revoke_access',
    // Snapshot related
    FilespaceCreateSnapshot: 'filespace_create_snapshot',
    FilespaceDeleteSnapshot: 'filespace_delete_snapshot',
    FilespaceListSnapshots: 'filespace_list_snapshots',
    // Snapshot schedules related
    FilespaceDeleteSnapshotSchedule: 'filespace_delete_snapshot_schedule',
    FilespaceListSnapshotSchedules: 'filespace_list_snapshot_schedules',
    // Data store (LucidLink Connect) related
    FilespaceListDataStores: 'filespace_list_data_stores',
    FilespaceDataStoreStats: 'filespace_data_store_stats',
    FilespaceListBucketObjects: 'filespace_list_bucket_objects',
    FilespaceAddDataStore: 'filespace_add_data_store',
    FilespaceRekeyDataStore: 'filespace_rekey_data_store',
    FilespaceRemoveDataStore: 'filespace_remove_data_store',
    // Browsing related
    FsEntryDirectLink: 'fs_entry_direct_link',
    FsEntryFollowLink: 'follow_link',
    FsEntryGuestLink: 'fs_entry_guest_link',
    GuestLinkData: 'guest_link_data',
};
export const FS_CLIENT_LOGOUT_TIMEOUT = 30 * ONE_MINUTE;
